export default "/app/global-wrapper-client/static/85b500cf885dca524367093a7a80752c.woff2";